import { CreateExtractTasksMode } from '~src/extractTask/actions/CreateExtractTaskAction';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { anyItemIsEmbeddedDatasource, anyItemIsUnpublishedWorkbook } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';
import { selectSpaceInfoItem } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IRefreshExtractAction } from '../../../spacesPlatform/models/actionNames';
import { createExtractRefresh } from '../../actions/extractRefresh/CreateExtractRefreshAction';


export const RefreshExtractsAction: IEntityAction<IContentInfo, IRefreshExtractAction> = {
  name: EntityActionNames.RefreshExtracts,
  translateName: Messages.extractTasks_action,
  isVisible: (targetItems: IContentInfo[]) => {
    return !anyItemIsEmbeddedDatasource(targetItems);
  },
  isClickable: (availableActions: IRefreshExtractAction, targetItems: IContentInfo[], state: AppState) => {
    const spaceItem = selectSpaceInfoItem(state);
    if (anyItemIsUnpublishedWorkbook(targetItems) || (!currentUserIsOwnerOrAdmin(state, spaceItem))) {
      return false;
    }

    return targetItems.length > 1 || !!(availableActions && availableActions.refreshExtract);
  },
  createReduxAction: (targetItems: IContentInfo[]) => createExtractRefresh(targetItems,
    getSessionManagementServiceInstance().isOnlineEnvironment() ?
      CreateExtractTasksMode.AllowRefreshNowAndOnServerAndClient : CreateExtractTasksMode.AllowRefreshNowAndOnServer)
};
